module.exports = "/images/apply.svg?1b42ae7b883fdcdc65dedf32557dab07";